// List of predefined business types
export const infoBusinessTypes = [
  { value: 0, label: "كفالة مريض" },
  { value: 1, label: "مساهمات طبية" },
  { value: 2, label: "بناء مسجد" },
  { value: 3, label: "صدقة يومية" },
  { value: 4, label: "وقف خيرة" },
  { value: 5, label: "زكاة" },
  { value: 6, label: "كفالة يتيم" },
  { value: 7, label: "تكافل اجتماعي" },
];

// List of cities
export const cities = [
  { value: 2, label: "أحد رفيدة" },
  { value: 3, label: "ابها" },
  { value: 4, label: "ابو عريش" },
  { value: 5, label: "احد المسارحة" },
  { value: 6, label: "احد رفيده" },
  { value: 7, label: "الاحساء" },
  { value: 8, label: "الباحة" },
  { value: 9, label: "البدائع" },
  { value: 10, label: "البكيرية" },
  { value: 11, label: "الثقبة" },
  { value: 12, label: "الجبيل" },
  { value: 13, label: "الجموم" },
  { value: 14, label: "الحريق" },
  { value: 15, label: "الحوطة" },
  { value: 16, label: "الحوية" },
  { value: 17, label: "الخبر" },
  { value: 18, label: "الخرج" },
  { value: 19, label: "الخرمة" },
  { value: 20, label: "الخفجي" },
  { value: 21, label: "الدرعية" },
  { value: 22, label: "الدلم" },
  { value: 23, label: "الدمام" },
  { value: 24, label: "الدوادمي" },
  { value: 25, label: "الرس" },
  { value: 26, label: "الرياض" },
  { value: 27, label: "الزلفي" },
  { value: 28, label: "السليل" },
  { value: 29, label: "الشماسية" },
  { value: 30, label: "الشنان" },
  { value: 31, label: "الطائف" },
  { value: 32, label: "الظهران" },
  { value: 33, label: "الغاط" },
  { value: 34, label: "الفريش" },
  { value: 35, label: "القريات" },
  { value: 36, label: "القطيف" },
  { value: 37, label: "القنفذة" },
  { value: 38, label: "القويعية" },
  { value: 39, label: "المبرز" },
  { value: 40, label: "المجاردة" },
  { value: 41, label: "المجمعة" },
  { value: 42, label: "المدينة المنورة" },
  { value: 43, label: "المذنب" },
  { value: 44, label: "المزاحمية" },
  { value: 45, label: "المظيلف" },
  { value: 46, label: "النعيرية" },
  { value: 47, label: "الهفوف" },
  { value: 48, label: "الوجه" },
  { value: 49, label: "املج" },
  { value: 50, label: "بارق" },
  { value: 51, label: "بحره" },
  { value: 52, label: "بدر" },
  { value: 53, label: "بريدة" },
  { value: 54, label: "بقيق" },
  { value: 55, label: "بللسمر" },
  { value: 56, label: "بيشة" },
  { value: 57, label: "بيشه" },
  { value: 58, label: "تاروت" },
  { value: 59, label: "تبوك" },
  { value: 60, label: "تثليث" },
  { value: 61, label: "تربه" },
  { value: 62, label: "ثادق" },
  { value: 63, label: "ثول" },
  { value: 64, label: "جازان" },
  { value: 65, label: "جدة" },
  { value: 66, label: "جيزان" },
  { value: 67, label: "حائل" },
  { value: 68, label: "حفر الباطن" },
  { value: 69, label: "حوطة بني تميم" },
  { value: 70, label: "خميس مشيط" },
  { value: 71, label: "خيبر" },
  { value: 72, label: "دومة الجندل" },
  { value: 73, label: "رأس تنورة" },
  { value: 74, label: "رابغ" },
  { value: 75, label: "رفحاء" },
  { value: 76, label: "رياض الخبراء" },
  { value: 77, label: "سكاكا" },
  { value: 78, label: "سيهات" },
  { value: 79, label: "شرورة" },
  { value: 80, label: "شروره" },
  { value: 81, label: "شقراء" },
  { value: 82, label: "صامطة" },
  { value: 83, label: "صبيا" },
  { value: 84, label: "صبياء" },
  { value: 85, label: "صفوى" },
  { value: 86, label: "ضبا" },
  { value: 87, label: "ضباء" },
  { value: 88, label: "طريف" },
  { value: 89, label: "عرعر" },
  { value: 90, label: "عفيف" },
  { value: 91, label: "عنك" },
  { value: 92, label: "عنيزة" },
  { value: 93, label: "قرية العليا" },
  { value: 94, label: "ليلى" },
  { value: 95, label: "محايل" },
  { value: 96, label: "مدينة الملك عبدالله الاقتصادية" },
  { value: 97, label: "مكة" },
  { value: 98, label: "نجران" },
  { value: 99, label: "وادي الدواسر" },
  { value: 100, label: "ينبع" },
  { value: 101, label: "ينبع البحر" },
];

// List of predefined color sets
export const predefinedColorSets = [
  "#41B06E,#141E46,#000000",
  "#AD6ED4,#0D0911,#000000",
  "#DB9C06,#0D0911,#000000",
  "#00ADB5,#222831,#000000",
  "#6C4E31,#0D0911,#000000",
];

// List of tabs for the association manager
export const tabsLi = [
  { link: "info", name: "البيانات الأساسية", icon: "InformationCircleIcon" },
  { link: "contacts", name: "بيانات التواصل", icon: "UserGroupIcon" },
  { link: "bank-accounts", name: "الحسابات البنكية", icon: "BuildingLibraryIcon" },
  { link: "licenses", name: "تراخيص الجمعية", icon: "IdentificationIcon" },
  { link: "interface", name: "الواجهة", icon: "SwatchIcon" },
];
